import React from 'react'

export const CheckIndicator = () => (
    <div className="m-auto block h-8 w-8">
        <img className="m-auto" src="/check.svg" />
    </div>
)
export default CheckIndicator
